import Filter from "core/filtering/filter";

export default class UnlockFilter extends Filter {
    memberId?: string;
    constructor(filter?: { memberId?: string }) {
        super({ $orderby: "Date desc" });
        this.memberId = filter?.memberId;
    }
}
